import { cn } from '@/shared/lib/utils'

export function ComplianceSubPageTitle({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <h3 className={cn('text-2xl font-bold', className)}>{children}</h3>
  )
}
